<template>
  <div class="isTxt" v-if="isTxt">
    <el-image
      v-for="(img, index) in imgList"
      :key="index"
      class="img-item"
      :src="img"
      :zoom-rate="1.2"
      :max-scale="7"
      :min-scale="0.2"
      preview-teleported
      :preview-src-list="imgList"
      fit="cover"
    />
  </div>
  <RxkUploadFile
    ref="RxkUploadFileRef"
    v-else
    class="customUpload"
    :limit="limit"
    :maxSize="20"
    :accept="accept"
    listType="picture"
    :fileList="list?.map?.((v: Recordable) => v.path) || []"
    :disabled="renderConfig.disabled"
    @handleSuccess="handleSuccess"
    @handleRemove="handleRemove"
  >
    <template #upload>
      <div style="width: 100%">
        <div
          v-if="!(limit === 1 && list.length)"
          class="uploadImg"
          :class="{ 'forbidden-upload': renderConfig.disabled }"
        >
          选择图片
        </div>
      </div>
    </template>
  </RxkUploadFile>
</template>
<script lang="ts" setup>
import { computed, ref, watch, unref } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkUploadFile } from '@/components/common/RxkUploadFile'
import { operateListEnum } from '@/enums/preObjectManage'
import globalEnv from '@/configs'

const RxkUploadFileRef = ref()

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'blur'])

const list = computed({
  get: () => {
    let temp = props.modelValue || props.data.value || []
    if (!(temp instanceof Array)) {
      try {
        temp = JSON.parse(temp)
      } catch (e) {
        console.log(e)
      }
    }
    return temp
  },
  set: val => {
    if (!val.length) {
      emit('update:modelValue', '')
      emit('blur', '')
    } else {
      emit('update:modelValue', JSON.stringify(val))
      emit('blur', JSON.stringify(val))
    }
  }
})

const imgList = computed(() => {
  if (unref(list) instanceof Array) {
    return unref(list)?.map((el: Recordable) => globalEnv.imgBaseUrl + el.path)
  }
  return []
})
const accept = '.jpg,.jpeg,.png,.gif'

// onMounted(() => {
//   let temp = props.modelValue || props.data.value || []
//   if(!(temp instanceof Array)){
//     try{
//       temp = JSON.parse(temp)
//     } catch(e){
//       console.log(e)
//     }
//   }
//   list.value = temp
//   console.log(list.value)
// })

// watch(() => list.value, () => {
//   if(!list.value.length){
//     emit('update:modelValue', '')
//   }else{
//     emit('update:modelValue', JSON.stringify(list.value))
//   }
// }, {
//   deep: true
// })

watch(
  () => props.modelValue,
  () => {
    RxkUploadFileRef?.value?.initPage()
  }
)

watch(
  () => props.data.value,
  () => {
    RxkUploadFileRef?.value?.initPage()
  }
)
const limit = computed(() => {
  console.log(props.data, 'pppp1')
  const columnOperateList = props.data.columnOperateList || []
  const current = columnOperateList.find(
    (item: Recordable) => item.code === operateListEnum.PICTURE_ONE
  )
  return current && current.value ? 1 : 10
})
function handleSuccess(_fileList: Recordable[], _file: Recordable, res: Recordable) {
  let tempArr = [...list.value]
  res.data.forEach((item: Recordable) => {
    tempArr.push({
      name: item.name,
      path: item.path
    })
  })
  list.value = tempArr
  // emit('blur', JSON.stringify(list.value))
}
function handleRemove(_fileList: any, file: any) {
  let path = file?.response?.data?.[0]?.path
  let tempArr = [...list.value]
  tempArr.forEach((e, i) => {
    if (e.path === path) tempArr.splice(i, 1)
  })
  list.value = tempArr
  // emit('blur', JSON.stringify(list.value || ''))
}
</script>
<style lang="scss" scoped>
.customUpload {
  width: 100%;
  :deep(.el-upload) {
    width: 100%;
  }
}
.uploadImg {
  height: 32px;
  line-height: 32px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  color: #5687ff;
}

.img-item {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.forbidden-upload {
  background-color: #f5f7fa;
  cursor: not-allowed;
}
</style>
